/* tslint:disable:max-classes-per-file */
import { h, Component } from 'preact'

interface IProps {
  children?: any[]
  [key: string]: any
}

class Provider extends Component<IProps, {}> {
  public getChildContext() {
    const { children, ...props } = this.props
    return { __CTX__: props }
  }
  public render() {
    return (this.props.children && this.props.children[0]) || null
  }
}

Provider.displayName = 'Provider'

type MapContextToProps = (object) => object

function connect(mapContextToProps?: MapContextToProps) {
  return (wrappedComponent: any) => {
    class Connected extends Component<{ [key: string]: any }, {}> {
      public mapContextToProps = (ctx: {}): object => {
        return mapContextToProps ? mapContextToProps(ctx) : ctx
      }
      public render() {
        return h(wrappedComponent, {
          ...this.mapContextToProps(this.context.__CTX__),
          ...this.props
        })
      }
    }
    Connected.displayName = `connect(${wrappedComponent.displayName ||
      wrappedComponent.name ||
      'Component'})`
    return Connected
  }
}

export { Provider, connect }
